export type LogoutReason = 'USER' | 'IDLE';

let recordedForToken: string | null = null;

/**
 * Tells the API that the user signed out, so it records the audit event
 * auth.session.logout (the user and session come from the token on the server).
 *
 * Fire and forget: it never delays or changes the sign-out. Sent at most once per
 * token, so an inactivity sign-out (IDLE), which calls the normal sign-out right after,
 * is not recorded twice. Uses fetch, not the API client, so a failed call can't start
 * a token refresh or a redirect; keepalive lets it finish while the app moves on.
 */
export const recordLogout = (reason: LogoutReason): void => {
  const token = localStorage.getItem('access_token');
  if (!token || token === recordedForToken) {
    return;
  }
  recordedForToken = token;

  try {
    fetch(`${process.env.REACT_APP_BASE_API_URL}/v1/fo/auth/logout`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ reason }),
    }).catch(() => undefined);
  } catch {
    // Never let the audit call get in the way of signing out.
  }
};
